import { render, staticRenderFns } from "./ProductPartners.vue?vue&type=template&id=ff868cfa"
import script from "./ProductPartners.vue?vue&type=script&lang=js"
export * from "./ProductPartners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports